export default {
    REWARDS: 'rewards',
    LOW_INTEREST: 'low-interest',
    BALANCE_TRANSFER: 'balance-transfer',
    SECURED: 'secured',
};
